module.exports = __webpack_public_path__ + "static/img/jx-xzjskx.e9dd831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/jx-xzjskx.png
// module id = JK+W
// module chunks = 0